// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { Distance, type DistanceWireFormat, NewDistance } from '../Distance/Distance';
import {
  NewTripDuration,
  TripDuration,
  type TripDurationWireFormat,
} from '../TripDuration/TripDuration';

export class DistanceDurationPair {
  readonly origin: string;
  readonly destination: string;
  readonly distance: Distance;
  readonly duration: TripDuration;

  constructor(data: { [key: string]: any } = {}) {
    this.origin = data.origin === undefined ? '' : data.origin;
    this.destination = data.destination === undefined ? '' : data.destination;
    this.distance = NewDistance(data.distance);
    this.duration = NewTripDuration(data.duration);
  }

  static zero(): DistanceDurationPair {
    const zeroValues: ExcludeMethodsDeep<DistanceDurationPair> = {
      origin: '',
      destination: '',
      distance: Distance.zero(),
      duration: TripDuration.zero(),
    };
    return new DistanceDurationPair(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DistanceDurationPairWireFormat = {
  origin: string;
  destination: string;
  distance: DistanceWireFormat;
  duration: TripDurationWireFormat;
};

type NewDistanceDurationPairProps = PartialDeep<DistanceDurationPair, { recurseIntoArrays: true }>;
export const NewDistanceDurationPair: (
  props: NewDistanceDurationPairProps,
) => DistanceDurationPair = (props) => new DistanceDurationPair(props);

type NewDistanceDurationPairFromWireFormatProps = PartialDeep<
  DistanceDurationPairWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDistanceDurationPairFromWireFormat: (
  props: NewDistanceDurationPairFromWireFormatProps,
) => DistanceDurationPair = (props) => new DistanceDurationPair(props);
